import { rgb } from 'pdf-lib';
import { MAX_ZOOM, MIN_ZOOM, ZOOM_PRESETS } from './constants';
import { ZoomPreset } from './types';
import { LibraryPage } from './interfaces';

export const hexToRgb = (hex: string): ReturnType<typeof rgb> => {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  return rgb(r, g, b);
};

export const hexToRgba = (hex?: string, opacity = 1): string => {
  if (!hex) {
    return 'rgba(255, 255, 255, 1)';
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const extractTextFromHtml = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

/**
 * Clamp zoom value to valid range
 */
export const clampZoom = (value: number): number => Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, value));

/**
 * Find nearest preset zoom level
 */
export const nearestPreset = (zoom: number): ZoomPreset => {
  const clamped = clampZoom(zoom);
  return ZOOM_PRESETS.reduce((nearest, preset) =>
    Math.abs(preset.value - clamped) < Math.abs(nearest.value - clamped) ? preset : nearest
  );
};

export const randomSuffix = () => Math.random().toString(36).substring(2, 6);

export const TestTypeMapping: Record<string, string> = {
  lactate: 'Lactate',
  newtype: 'PPD',
  map: 'PPD',
  manual: 'Manual',
  virtual: 'Virtual',
};

/**
 * This should ideally _always_ use the unique template key
 */
export const UniquePageKey = (page: LibraryPage): number => page.unique_template_key ?? page.id;
